import React from "react";
import { Bubble, Hint, Trailing, Wrapper } from "./Tooltip.styles";
import type { TooltipProps } from "./Tooltip.types";

/**
 * CSS-driven tooltip atom. No useState — purely declarative via :hover / :focus-within.
 *
 * Usage:
 *   <Tooltip label="Zoom in" position="left" variant="dark">
 *     <button>...</button>
 *   </Tooltip>
 *
 * Variants:  dark (default) | primary | light
 * Positions: left (default) | right | top | bottom
 */
export const Tooltip: React.FC<TooltipProps> = ({
  label,
  position = "left",
  variant  = "dark",
  children,
  className,
  multiline = false,
  maxWidth,
  trailing,
  hint,
  arrow = true,
}) => (
  <Wrapper className={className}>
    {children}
    <Bubble
      $position={position}
      $variant={variant}
      $multiline={multiline}
      $maxWidth={maxWidth}
      $arrow={arrow}
      data-arrow={arrow ? "true" : "false"}
      role="tooltip"
      aria-label={label}
    >
      {label}
      {hint || trailing ? (
        <Trailing aria-hidden>
          {hint ? <Hint>{hint}</Hint> : null}
          {trailing}
        </Trailing>
      ) : null}
    </Bubble>
  </Wrapper>
);

export default Tooltip;
